<template>
	<v-flex >
		<v-data-table
			:headers="headers"
			:items="accounts"
			hide-actions
			class="accountTable acctscroller"
			>
		  	<template slot="items" slot-scope="props">
				<!-- <td class="caption" v-for="header in headers" >
					{{ props.item[header.value] }}
				</td> -->
				<td class="caption">{{props.item.accountno}}</td>
				<td class="caption">{{props.item.description}}</td>
				<td class="caption">{{props.item.accountHigherEdFunctionCD}}</td>
				<td class="caption">{{props.item.accountFederalFunctionCD}}</td>
				<td class="caption">{{props.item.accountCostSubcategoryCD}}</td>

				<td class="justify-start pr-3">
					<v-flex>
					<v-tooltip left>
	              		<v-dialog slot="activator" v-model="dialog[props.item.accountno]" persistent max-width="290">
		                
		                	<v-icon slot="activator" small color="red lighten-2">close</v-icon>
		                
			                <v-card class="pl-2 pt-1 pr-2">
						        <v-card-title class="headline">Delete</v-card-title>
						        <v-divider></v-divider>
						        <v-card-text class="pt-4 body-2">Delete {{props.item.accountno}}?</v-card-text>
						        <v-card-actions>
						          	<v-spacer></v-spacer>
						          	<v-btn color="green darken-1" flat @click.native="dialog[props.item.accountno] = false">No</v-btn>
						          	<v-btn color="green darken-1" flat 
						          		@click.native="delAccount(props.item.key)">Yes
						      	 	 </v-btn>
						        </v-card-actions>
					      	</v-card>
				    	</v-dialog>
		                <span>Delete</span>
		            </v-tooltip>
		        </v-flex>
				</td>
		  	</template>
		  	<template slot="no-data">
				No Accounts
		  	</template>
		</v-data-table>
	</v-flex>
</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
data () {
	return {	dialog: {},
				headers: [
			        { text: 'Account',	align: 'left',	value: 'accountno' },
			        { text: 'Description', 				value: 'description' },
			        { text: 'Higher Ed', 			value: 'accountHigherEdFunctionCD' },
			        { text: 'Fed Func', 	value: 'accountFederalFunctionCD' },
			        { text: 'Cost Subcat', 				value: 'accountCostSubcategoryCD' },
/*			        { text: 'departmenet', 	value: 'departmenet' },
			        { text: 'college', 	value: 'college' },
			        { text: 'responsiblePersonID', 	value: 'responsiblePersonID' },
			        { text: 'responsiblePerson', 	value: 'responsiblePerson' },
			        { text: 'pi', 	value: 'pi' },
			        { text: 'hierarchyIDS', 	value: 'hierarchyIDS' },
			        { text: 'dateUpdated', 	value: 'dateUpdated' },
			        { text: 'dateAdded', 	value: 'dateAdded' },
			        { text: 'deteInactive', 	value: 'deteInactive' },
			        { text: 'currentAccount', 	value: 'currentAccount' },*/	
			        { text: '', value: null}		        
			        
			      ],
	}
},

components: {  },

computed: {
	...mapState({   	room: 				state => state.dv.room,
						deptSelectedIndex: 	state => state.dv.deptSelectedIndex,
				}),

	accounts: function () {
		return this.room ? this.room.PCT[this.deptSelectedIndex].account : []
	},

	


},

methods : {
	//...mapMutations([ 	'',					]),

	...mapActions([		'deleteAccount', 'fetchFullRoom', 'setRoom',
				  ]),

	markOccupantInactive: function (occupant, i) {
		this.removeOccupantDialog[i] = false
		occupant.current = false
		this.updateOccupant({ key: occupant.key, current: false })
		occupant.splice(i, 1) // Remove from local memory
	},

	delAccount: function (accountKey) {
		this.deleteAccount({ key: accountKey })
		this.refreshRoom()

	},

	refreshRoom: function () {
		this.fetchFullRoom({bldgAlpha: this.room.bldgAlpha, number: this.room.number, noSet: true}).then((data) => this.setRoom(data) )
	},
},
}

</script>

<style>
.acctscroller {	
	overflow-y: auto;
	height: calc(50vh - 200px) !important; 
}

.accountTable {
	width: 100%;
	overflow-y: auto;
	overflow-x: auto;
}

/* this technique gets deeply nested th td selectors */
.accountTable th { padding-left: 20px !important; }
.accountTable td { padding-left: 20px !important; }
.accountTable .v-table__overflow { 
	overflow-x: unset !important;
	overflow-y: unset !important;
 }

 .accountTable .table {
 	padding-left: 30px;
 	border-radius: 0px;
 }
</style>



// WEBPACK FOOTER //
// src/components/RoomViewer/RoomDetailAccounts.vue